import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesaparecidoSaludService {
  constructor(private http: HttpClient) { }

  findAll(idDesaparecido: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/${idDesaparecido}/salud`);
  }
}
